import { createHeldFlag } from './heldFlag';

/**
 * The phone map holds MobileNav's More drawer open while Lumio tells the parts that live in it. Product behaviour is
 * unchanged: the drawer otherwise opens and closes on a tap alone.
 */
const moreHeld = createHeldFlag();

/** Holds the phone's More drawer open (true), or lets it close the usual way (false). */
export const setMoreHeld = moreHeld.set;

/** Whether the FTUX holds the phone's More drawer open: MobileNav keeps it open and ignores its own toggles. */
export const useMoreHeld = moreHeld.useHeld;
